import { transparentize } from 'polished'
import styled from 'styled-components/macro'

const Select = styled.select`
  border: 1px solid ${props => props.theme.colors.bg300};
  padding: 8px;
  font-size: 1rem;
  height: 40px;
  border-radius: ${props => props.theme.rounding.medium};
  margin-bottom: 8px;
  width: 100%;
  background-color: ${props => props.theme.colors.bg0};
  color: ${props => props.theme.colors.text0};

  &:focus {
    border: 1px solid ${props => props.theme.colors.primary};
    box-shadow: 0 0 2px 2px
      ${props => transparentize(0.5, props.theme.colors.primary)};
    outline: none;
  }

  &:disabled {
    background-color: ${props => props.theme.colors.bg300};
  }

  transition: border ${props => props.theme.transitions.short} ease,
    background-color ${props => props.theme.transitions.short} ease,
    box-shadow ${props => props.theme.transitions.short} ease,
    opacity ${props => props.theme.transitions.short} ease,
    color ${props => props.theme.transitions.short} ease;
`

export default Select
